import React, { useEffect } from "react";
import { observer } from "mobx-react";
import Utils from "Utils/utils";
import DashboardState from "../mainState";
import { DATE_FILTER_LIST } from "../ReportsModule/constants";
import linkedInAutomationState from "./state";
import LinkedInAutomationUtils from "./utils";

const LinkedInAutomationFilter = observer(() => {
  const makeFilterRequest = (payload, obj) => {
    obj &&
      Object.keys(obj).length &&
      linkedInAutomationState.setFilterPayload({ ...payload, ...obj });
    linkedInAutomationState.getLinkedInAnalyticsData(payload);
  };

  const getFilterPayload = value => {
    const { firstDate = "", lastDate = "" } =
      LinkedInAutomationUtils.getInsightsAnalyticsPayload(value);
    const filterPayload = {
      timeZone: Utils.getCurrentUserTimeZone(),
      filterFromDate: firstDate,
      filterToDate: lastDate
    };
    return filterPayload;
  };

  const getTabValue = value => {
    linkedInAutomationState.setLinkedInInsightLoader(true);
    linkedInAutomationState.setActiveLinkedInInsightTab(value);
    const payload = getFilterPayload(value) || "";
    const today = new Date();
    makeFilterRequest(payload, {
      value,
      days: value?.includes("week")
        ? 7
        : value?.includes("lastMonth")
        ? new Date(today.getFullYear(), today.getMonth(), 0)
        : new Date(today.getFullYear(), today.getMonth() + 1, 0)
    });
  };

  const constructFilterPayload = () => {
    const payload =
      getFilterPayload(linkedInAutomationState.activeLinkedInInsightTab) || "";
    return payload || {};
  };

  useEffect(() => {
    linkedInAutomationState.setLinkedInInsightLoader(true);
    const payload = constructFilterPayload();
    const value = linkedInAutomationState.activeLinkedInInsightTab;
    const today = new Date();
    const days = value?.includes("week")
      ? 7
      : value?.includes("lastMonth")
      ? new Date(today.getFullYear(), today.getMonth(), 0)
      : new Date(today.getFullYear(), today.getMonth() + 1, 0);
      
    linkedInAutomationState.setFilterPayload({ ...payload, value, days });
    linkedInAutomationState.getLinkedInAnalyticsData(payload);
  }, [DashboardState?.memberId]);

  return (
    <div className="dateFilter">
      {DATE_FILTER_LIST?.length &&
        DATE_FILTER_LIST.map(item => {
          const { name = "", id = "", value = "" } = item || {};
          return (
            item?.name !== "Custom" && (
              <div
                className={`tabItem ${
                  linkedInAutomationState?.activeLinkedInInsightTab === value
                    ? "active"
                    : ""
                }`}
                id={id}
                key={id}
                onClick={() => getTabValue(value)}
              >
                <span>{name}</span>
              </div>
            )
          );
        })}
    </div>
  );
});

export { LinkedInAutomationFilter };
export default LinkedInAutomationFilter;
